import { useEffect, type FC } from 'react';
import { Trans } from 'react-i18next';

import { type OverduePaymentButtonData, type OverduePaymentButtonHandlers } from '@ctct/application-layer';
import { getEnv } from '@ctct/ctct-helpers';
import { PayButton } from '@ctct/presentation-layer';
import type { OverduePaymentButtonHooks } from '@ctct/state-client-layer';

import { useIsMobile } from '../../hooks';

interface Props {
  data: OverduePaymentButtonData;
  handlers: OverduePaymentButtonHandlers;
  hooks: OverduePaymentButtonHooks;
}

// Avoid ESLint accessibility warnings if we simply use `<a>` for the button.
const EmptyLink = 'a' as unknown as FC<JSX.IntrinsicElements['a']>;

export const OverduePaymentButtonWidgetContent = ({ data, handlers, hooks }: Props) => {
  const disabled = hooks.useDisabled();
  const termsTransKey = data.getTermsTransKey();

  const { isMobile } = useIsMobile();

  useEffect(() => {
    handlers.onMobileUpdate(isMobile);
  }, [isMobile, handlers]);

  return (
    <PayButton
      disabled={disabled}
      onClick={handlers.onPayButtonClick}
      buttonLabel={data.getButtonLabel()}
      terms={
        <Trans
          i18nKey={termsTransKey}
          components={{
            Terms: (
              <EmptyLink
                className="link"
                target="_blank"
                rel="nofollow noreferrer"
                href={`https://www${getEnv()}constantcontact.com/legal/terms`}
              />
            ),
          }}
        />
      }
      variant={data.isLoading() ? 'loading' : undefined}
    />
  );
};
